// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".handle[data-v-4244fdbb]{cursor:move;color:#888}", ""]);
// Exports
module.exports = exports;
